'use strict'

var G = require('window-or-global')

module.exports = function() {
  return (
    typeof G.Promise === 'function' &&
    typeof G.Promise.prototype.then === 'function'
  )
}



//////////////////
// WEBPACK FOOTER
// ./~/_can-promise@0.0.1@can-promise/index.js
// module id = 1494
// module chunks = 0